<template>
  <div ref="draggable" class="draggable" :style="{ top: position.y + 'px', left: position.x + 'px' }"
    @mousedown="startDrag" @click="handleClick">
    <slot />
  </div>
</template>

<script>
export default {
  name: "FtsDraggable",
  data() {
    return {
      position: { x: 0, y: 0 },
      dragging: false,
      offset: { x: 0, y: 0 },
      moved: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.repositionInsideScreen();

      const el = this.$refs.draggable;
      const rect = el.getBoundingClientRect();
      this.position = {
        x: window.innerWidth - rect.width - 50,
        y: window.innerHeight - rect.height - 50
      };
    });
    window.addEventListener("resize", this.repositionInsideScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.repositionInsideScreen);
  },
  methods: {
    startDrag(e) {
      this.dragging = true;
      this.moved = false;
      this.offset = {
        x: e.clientX - this.position.x,
        y: e.clientY - this.position.y
      };
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(e) {
      if (!this.dragging) return;
      this.moved = true;

      const el = this.$refs.draggable;
      const rect = el.getBoundingClientRect();

      let newX = e.clientX - this.offset.x;
      let newY = e.clientY - this.offset.y;

      // clamp inside screen
      newX = Math.max(0, Math.min(window.innerWidth - rect.width, newX));
      newY = Math.max(0, Math.min(window.innerHeight - rect.height, newY));

      this.position = { x: newX, y: newY };
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    handleClick(e) {
      if (this.moved) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    repositionInsideScreen() {
      this.$nextTick(() => {
        const el = this.$refs.draggable;
        if (!el) return;
        const rect = el.getBoundingClientRect();

        let newX = this.position.x;
        let newY = this.position.y;

        // clamp inside screen
        newX = Math.max(0, Math.min(window.innerWidth - rect.width, newX));
        newY = Math.max(0, Math.min(window.innerHeight - rect.height, newY));

        this.position = { x: newX, y: newY };
      });
    }
  }
};
</script>

<style scoped>
.draggable {
  position: fixed;
  cursor: move;
  user-select: none;
  z-index: 9999;
}
</style>
